if (!customElements.get('collection-discovery')) {
  customElements.define('collection-discovery', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.form = this.querySelector('[data-filter-form]');
      this.fallback = this.querySelector('[data-filter-fallback]');
      this.dialog = this.querySelector('[data-filter-dialog]');
      this.trigger = this.querySelector('[data-filters-open]');
      this.target = this.querySelector('[data-filter-target]');
      this.sort = this.querySelector('[name="sort_by"]');
      if (!this.form || !this.fallback || !this.dialog || !this.trigger || !this.sort) return;
      this.desktop = matchMedia('(min-width: 990px)');
      this.intro = this.closest('.shopify-section')?.querySelector('[data-collection-intro]');
      const nativeFiltersOpen = this.fallback.open;
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.trigger.setAttribute('aria-controls', this.dialog.id);
      this.sort.addEventListener('change', () => this.form.requestSubmit(), options);
      this.form.addEventListener('formdata', event => {
        event.formData.set('sort_by', this.sort.value);
        for (const input of this.form.querySelectorAll('input[type="number"]')) {
          if (!input.value) event.formData.delete(input.name);
        }
      }, options);
      this.priceMin = this.form.querySelector('[data-price-min]');
      this.priceMax = this.form.querySelector('[data-price-max]');
      this.priceError = this.form.querySelector('[data-price-error-message]');
      this.priceTouched = false;
      this.form.addEventListener('input', () => this.validatePrice(), options);
      window.addEventListener('pageshow', () => this.validatePrice(), options);
      this.validatePrice();
      this.form.addEventListener('invalid', event => {
        if (!this.desktop.matches && !this.dialog.open) this.openFilters();
        let disclosure = event.target.closest('details');
        while (disclosure) {
          disclosure.open = true;
          disclosure = disclosure.parentElement?.closest('details');
        }
        this.priceTouched = true;
        this.validatePrice();
      }, { ...options, capture: true });
      this.trigger.addEventListener('click', event => { event.preventDefault(); this.openFilters(); }, options);
      this.querySelector('[data-filters-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        event.stopPropagation();
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.dialog.open) return;
        document.documentElement.classList.remove('ny-filter-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.isConnected && !this.desktop.matches) this.trigger.focus({ preventScroll: true });
      }, options);
      this.desktop.addEventListener('change', () => this.syncLayout(), options);
      this.syncLayout();
      if (nativeFiltersOpen && !this.desktop.matches) this.openFilters();
    }

    validatePrice() {
      const min = this.priceMin, max = this.priceMax;
      if (!min || !max) return;
      max.setCustomValidity(min.value && max.value && Number(min.value) > Number(max.value) ? this.form.dataset.priceError : '');
      const invalid = [min, max].find(input => !input.validity.valid);
      for (const input of [min, max]) {
        if (this.priceTouched && !input.validity.valid) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
      }
      if (this.priceError) {
        this.priceError.hidden = !this.priceTouched || !invalid;
        this.priceError.textContent = this.priceTouched && invalid ? invalid.validationMessage : '';
      }
    }

    openFilters() {
      if (this.dialog.open || this.desktop.matches) return;
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ny-filter-open');
    }

    syncLayout() {
      const desktop = this.desktop.matches;
      const hadDialogFocus = this.dialog.contains(document.activeElement);
      if (this.dialog.open) this.dialog.close();
      document.documentElement.classList.remove('ny-filter-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      (desktop ? this.fallback : this.target).append(this.form);
      this.fallback.hidden = !desktop;
      this.fallback.open = desktop;
      this.trigger.hidden = desktop;
      if (this.intro) this.intro.open = desktop;
      if (hadDialogFocus && desktop) this.sort.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.abort?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('ny-filter-open');
      if (this.form && this.fallback) this.fallback.append(this.form);
      if (this.fallback) { this.fallback.hidden = false; this.fallback.open = false; }
      if (this.trigger) {
        this.trigger.hidden = false;
        for (const name of ['aria-haspopup', 'aria-controls', 'aria-expanded']) this.trigger.removeAttribute(name);
      }
    }
  });
}
